import React, { useEffect, useContext, useState } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import PhotoSwipeLightbox from "photoswipe/lightbox";
import "photoswipe/style.css";
import { Link } from "react-router-dom";
import { AppSettings } from "./../../config/app-settings.js";
import { Card, CardBody, CardFooter } from "../../components/card/card";
import ConfirmationDlg from "../../components/ConfirmationDlg";

function Documents() {
  const [openDlg, setOpenDlg] = useState(false);
  const context = useContext(AppSettings);

  useEffect(() => {
    context.setAppContentFullHeight(true);
    context.setAppContentClass("p-0");
    context.setAppSidebarCollapsed(true);

    var lightbox;

    if (!lightbox) {
      lightbox = new PhotoSwipeLightbox({
        gallery: ".gallery-image-list",
        children: "a",
        pswpModule: () => import("photoswipe"),
      });
      lightbox.init();
    }

    return function cleanUp() {
      context.setAppContentFullHeight(false);
      context.setAppContentClass("");
      context.setAppSidebarCollapsed(false);

      if (lightbox) {
        lightbox.destroy();
        lightbox = null;
      }
    };

    // eslint-disable-next-line
  }, []);

  function closeDialog() {
    setOpenDlg(false);
  }

  return (
    <div className="d-block d-md-flex align-items-stretch h-100">
      <ConfirmationDlg
        open={openDlg}
        onClose={closeDialog}
        btnSubmitText={"Submit"}
        btnCancelText={"Cancel"}
      >
        <div className="form-group mb-3">
          <label>Title</label>
          <input type="text" className={"form-control"} />
        </div>
        <div className="form-group mb-3">
          <label>Description</label>
          <textarea type="text" className={"form-control"}>
            {" "}
          </textarea>
        </div>
        <div className="form-group">
          <label>File</label>
          <input type="file" className={"form-control"} />
        </div>
      </ConfirmationDlg>
      <div className="gallery-menu-container">
        <PerfectScrollbar className="h-100">
          <div className="gallery-menu">
            <div className="p-3 d-flex align-items-center">
              <Link
                to="/"
                className="btn btn-outline-default text-nowrap btn-sm px-3 rounded-pill"
              >
                <i className="fa fa-arrow-left me-1 ms-n1"></i> Back
              </Link>
            </div>
            <div className="gallery-menu-header">Main</div>
            <div className="gallery-menu-item">
              <a href="#/" className="gallery-menu-link active">
                <i className="fa fa-fw fa-file-pdf me-1"></i> Documents
              </a>
            </div>
            <div className="gallery-menu-item">
              <a href="/document/doc-chat" className="gallery-menu-link active">
                <i className="fa fa-fw fa-message me-1"></i> AI Chat
              </a>
            </div>
          </div>
        </PerfectScrollbar>
      </div>
      <div className="gallery-content-container">
        <PerfectScrollbar className="h-100">
          <div className="gallery-content">
            <div className="gallery">
              <div className="d-flex align-items-center mb-3">
                <div className="gallery-title mb-0">
                  <a href="#/">
                    Documents <i className="fa fa-chevron-right"></i>
                    <small>May 11, 2024</small>
                  </a>
                </div>

                <div
                  className="ms-auto btn-group"
                  onClick={() => setOpenDlg(true)}
                >
                  <a href="#/" className="btn btn-outline-default btn-sm">
                    <i className="fa fa-upload"></i> Upload Docs
                  </a>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-3">
                  <a
                    href="/assets/doc/tutorial1.pdf"
                    target={"_blank"}
                    style={{ textAlign: "center", textDecoration: "none" }}
                  >
                    <Card>
                      <CardBody>
                        <i
                          className="fa fa-file-pdf"
                          style={{ fontSize: "80px" }}
                        ></i>
                      </CardBody>
                      <CardFooter
                        style={{
                          textAlign: "center",
                          fontWeight: "bold",
                        }}
                      >
                        Machine Documentation 1
                      </CardFooter>

                      <CardFooter
                        style={{
                          textAlign: "left",
                        }}
                      >
                        <div>Date Uploaded: 2024-07-11</div>
                        <div>
                          Status:{" "}
                          <span className={"badge bg-info"}>Completed</span>
                        </div>
                      </CardFooter>
                    </Card>
                  </a>
                </div>
                <div className="col-sm-3">
                  <a
                    href="/assets/doc/tutorial1.pdf"
                    target={"_blank"}
                    style={{ textAlign: "center", textDecoration: "none" }}
                  >
                    <Card>
                      <CardBody>
                        <i
                          className="fa fa-file-pdf"
                          style={{ fontSize: "80px" }}
                        ></i>
                      </CardBody>
                      <CardFooter
                        style={{
                          textAlign: "center",
                          fontWeight: "bold",
                        }}
                      >
                        Machine Documentation 2
                      </CardFooter>

                      <CardFooter
                        style={{
                          textAlign: "left",
                        }}
                      >
                        <div>Date Uploaded: 2024-07-11</div>
                        <div>
                          Status:{" "}
                          <span className={"badge bg-warning"}>
                            In Progress
                          </span>
                        </div>
                      </CardFooter>
                    </Card>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </PerfectScrollbar>
      </div>
    </div>
  );
}

export default Documents;
